import React from 'react';
import { Badge } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';

export const OutOfStockBadge: React.FC = () => {
  const { tq } = useTranslation('catalogRegistry');

  return (
    <Badge
      variant="glass"
      intent="warning"
      size="sm"
      position="absolute"
      top={pxToRem(12)}
      right={pxToRem(12)}
      zIndex={1}
    >
      {tq`Out of Stock`}
    </Badge>
  );
};
